"use client"

import React from 'react'
import { Button } from './ui/button'
import { useGoogleSignIn } from './useGoogleSignIn';
import Link from 'next/dist/client/link';

export default function GoogleLoginButton() {
    const { loading, signIn } = useGoogleSignIn();

    return (
        <Button
            asChild
            size="lg"
            variant="secondary"
            disabled={loading}
            onClick={signIn}
            className="rounded-xl px-5 text-base">
            <Link href="#">
                <span className="text-nowrap">Continue with Google</span>
            </Link>
        </Button>
    )
}
